import React, { useEffect, useState } from 'react';
import logo from '../../../images/bluelogo.png';
import Cookies from 'js-cookie';
import { requestClassByProtocol } from '../../../services/requests';
import { requestNeverevents } from '../../../services/newNotesRequest';

export default function NewClassificacaoPreenchido({
	notificacao,
	classificacao = null,
}) {
	const [formData, setFormData] = useState({
		incidente: '',
		neverEvent: '',
		prazoConclusao: '',
	});
	const [rawIncidente, setRawIncidente] = useState('');
	const [subChoices, setSubChoices] = useState(null);

	const formatIncidente = (value) => {
		if (!value) return '';
		const noSeparators = value.replace(/[_-]+/g, ' ');
		const lower = noSeparators.toLowerCase();
		return lower.charAt(0).toUpperCase() + lower.slice(1);
	};

	const formatDateBr = (value) => {
		if (!value) return '';
		// aceita 'YYYY-MM-DD' ou ISO 'YYYY-MM-DDTHH:MM:SS'
		const onlyDate = value.split('T')[0];
		const [year, month, day] = onlyDate.split('-');
		if (!year || !month || !day) return value;
		return `${day}/${month}/${year}`;
	};

	useEffect(() => {
		const loadClassificacao = async () => {
			try {
				if (!notificacao?.protocolo) return;

				const userCookie = Cookies.get('user');
				if (!userCookie) return;

				const { token } = JSON.parse(userCookie);
				if (!token) return;

				const result =
					classificacao && !classificacao.error
						? classificacao
						: await requestClassByProtocol(
								token,
								notificacao.protocolo,
							);

				if (!result || result.error) return;

				// carrega mapa de Never Events (sub_classificacao) se ainda não carregado
				let choicesMap = subChoices;
				if (!choicesMap) {
					const choices = await requestNeverevents(token);
					if (!choices || choices.error) {
						choicesMap = null;
					} else {
						choicesMap = choices.sub_classificacao || null;
						setSubChoices(choicesMap);
					}
				}

				// o endpoint retorna a última classificação da notificação
				// ajusta aqui conforme o shape real do objeto retornado
				const incidenteRaw = result.classificacao || '';
				const subRaw = result.sub_classificacao || '';

				let neverEventNome = subRaw;
				if (choicesMap && subRaw) {
					// em choices.sub_classificacao cada chave é um id e o objeto possui nome/codigo
					const entry = Object.values(choicesMap).find(
						(item) =>
							item.codigo === subRaw ||
							String(item.id) === String(subRaw),
					);
					if (entry && entry.nome) {
						neverEventNome = entry.nome;
					}
				}
				setRawIncidente(incidenteRaw);
				setFormData({
					incidente: formatIncidente(incidenteRaw),
					neverEvent: neverEventNome,
					prazoConclusao: formatDateBr(result.prazo_investigacao),
				});
			} catch (error) {
				console.error('Erro ao carregar classificação:', error);
			}
		};

		loadClassificacao();
	}, [notificacao?.protocolo, classificacao]);

	return (
		<div className=' max-w-[1136px] font-inter  bg-white '>
			{/* Header */}
			{/* <div className='bg-[#F0F4F8] flex rounded-sm w-full content-center min-h-[120px] p-[16px] gap-[20px] justify-between lg:flex-row flex-col'>
				<div className='content-center items-center mx-auto'>
					<img
						className='w-[200px] h-auto'
						src={logo}
						alt='logo'
					/>
				</div>
				<p className='text-[24px] font-bold text-[#13335A] content-center max-w-[600px] text-center'>
					NOTIFICAÇÃO DE INCIDENTES E NÃO CONFORMIDADES
				</p>
			</div> */}

			{/* CLASSIFICAÇÃO DO INCIDENTE */}
			<div className='flex flex-col border-[1px] border-[#E3E3E3] rounded-md mt-[16px]'>
				<p className='text-[#004A80] bg-[#F4F4F4] rounded-t-md text-[18px] text-center font-semibold font-inter border-[#E3E3E3] border-b-[1px] py-1'>
					CLASSIFICAÇÃO DO INCIDENTE
				</p>

				<div className='p-3 w-full'>
					<p className='text-[#004A80] font-medium'>Incidente</p>
					<div className='h-[40px] flex items-center px-2 border-[1px] rounded-md border-[#E3E3E3]'>
						{formData.incidente}
					</div>
				</div>

				{rawIncidente === 'NEVER_EVENTS' && (
					<>
						<div className='h-[1px] w-[97.5%] mx-auto bg-[#E3E3E3]'></div>
						<div className='p-3 w-full'>
							<p className='text-[#004A80] font-medium'>
								Never Event
							</p>

							<div className='h-[40px] flex items-center px-2 border-[1px] rounded-md border-[#E3E3E3]'>
								{subChoices[formData.neverEvent].nome}
							</div>
						</div>
					</>
				)}
			</div>

			{/* ANÁLISE DO INCIDENTE */}
			<div className='flex flex-col border-[1px] border-[#E3E3E3] rounded-md mt-[16px]'>
				<p className='text-[#004A80] bg-[#F4F4F4] rounded-t-md text-[18px] text-center font-semibold font-inter py-1 border-[#E3E3E3] border-b-[1px]'>
					ANÁLISE DO INCIDENTE
					<span className='block text-[16px] font-normal'>
						Preenchido pelo Núcleo de Segurança do Paciente
					</span>
				</p>

				<div className='p-3 w-full flex flex-col gap-2'>
					<p className='text-[#004A80] font-medium'>
						Prazo máximo para a conclusão da investigação
					</p>
					<div className='h-[40px] flex items-center px-2 border-[1px] rounded-md border-[#E3E3E3]'>
						{formData.prazoConclusao}
					</div>
				</div>
			</div>
		</div>
	);
}
